const o = [
  "Invalid JWT Token",
  "JWT Token not found",
  "Expired JWT Token"
];
class r extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
export {
  r as InvalidTokenError,
  o as invalidTokenErrorMessages
};
